import apiClient from '@shared/services/apiClient';
import type { JobSite, CreateJobSiteRequest, UpdateJobSiteRequest } from '../types/jobSite';

export const getJobSites = async (customerId: number): Promise<JobSite[]> => {
  const response = await apiClient.get(`/customers/${customerId}/job-sites`);
  return response.data;
};

export const createJobSite = async (
  customerId: number,
  request: CreateJobSiteRequest
): Promise<JobSite> => {
  const response = await apiClient.post(`/customers/${customerId}/job-sites`, request);
  return response.data;
};

/** Edit a JobSite; billing routing, geocoding, and the flag are preserved server-side. */
export const updateJobSite = async (
  customerId: number,
  locationId: number,
  request: UpdateJobSiteRequest
): Promise<JobSite> => {
  const response = await apiClient.put(`/customers/${customerId}/job-sites/${locationId}`, request);
  return response.data;
};

/** Promote a JobSite back to a normal location (removes only the flag). */
export const removeJobSiteFlag = async (
  customerId: number,
  locationId: number
): Promise<void> => {
  await apiClient.delete(`/customers/${customerId}/job-sites/${locationId}`);
};
